import Api from "@/api/index";
// import store from "@/store";
// import alerts from "@/components/alerts/alert";
// import router from "@/router";

const regions = {
  namespaced: true,
  state: {
    provinces: [],
    regencies: [],
    districts: [],
    villages: [],
    queryParam: {},
    cities: [],
  },
  getters: {
    getDatas(state) {
      return state.datas;
    },
  },
  mutations: {
    SET_PROVINCE(state, datas) {
      state.provinces = datas;
    },
    SET_REGENCY(state, datas) {
      state.regencies = datas;
    },
    SET_DISTRICT(state, datas) {
      state.districts = datas;
    },
    SET_VILLAGE(state, datas) {
      state.villages = datas;
    },
    SET_CITY(state, datas) {
      state.cities = datas;
    },
    SET_LOADING(state, loading) {
      state.loading = loading;
    },
    SET_QUERY_PARAM(state, data) {
      state.queryParam = data;
    },
  },
  actions: {
    async getCity({ commit }, payload) {
      commit("SET_LOADING", true);
      commit("SET_QUERY_PARAM", payload);
      return await Api.doGet("city").then(({ data }) => {
        commit("SET_CITY", data);
        commit("SET_LOADING", false);
      });
    },
    async getProvince({ commit }, payload) {
      commit("SET_LOADING", true);
      commit("SET_QUERY_PARAM", payload);
      return await Api.doGet("provinces").then(({ data }) => {
        commit("SET_PROVINCE", data);
        commit("SET_LOADING", false);
      });
    },
    async getRegency({ commit }, payload) {
      commit("SET_LOADING", true);
      commit("SET_QUERY_PARAM", payload);
      return await Api.doGet(`regencies/${payload}`).then(({ data }) => {
        commit("SET_REGENCY", data);
        commit("SET_LOADING", false);
      });
    },
    async getDistrict({ commit }, payload) {
      commit("SET_LOADING", true);
      commit("SET_QUERY_PARAM", payload);
      return await Api.doGet(`districts/${payload}`).then(({ data }) => {
        commit("SET_DISTRICT", data);
        commit("SET_LOADING", false);
      });
    },
    async getVillage({ commit }, payload) {
      commit("SET_LOADING", true);
      commit("SET_QUERY_PARAM", payload);
      return await Api.doGet(`villages/${payload}`).then(({ data }) => {
        commit("SET_VILLAGE", data);
        commit("SET_LOADING", false);
      });
    },
  },
};

export default regions;
